import { render, staticRenderFns } from "./specheckout.vue?vue&type=template&id=a5e48b70"
import script from "./specheckout.vue?vue&type=script&lang=js"
export * from "./specheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports